import { render, staticRenderFns } from "./FilterChannel.vue?vue&type=template&id=241f8cc2&scoped=true&"
import script from "./FilterChannel.vue?vue&type=script&lang=js&"
export * from "./FilterChannel.vue?vue&type=script&lang=js&"
import style0 from "./FilterChannel.vue?vue&type=style&index=0&id=241f8cc2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241f8cc2",
  null
  
)

export default component.exports